import React from 'react'
import { SiteProvider } from '@/context/SiteContext'
import './src/styles/globals.css'

export const wrapRootElement = ({ element }) => (
  <SiteProvider>{element}</SiteProvider>
)

const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}

export { onServiceWorkerUpdateReady }
